module.exports = __webpack_public_path__ + "static/media/coachPrice.30866027.svg";